import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import SearchResultsTable from '../components/SearchResultsTable';
import {fetchUsers, onDeleteUser} from '../actions/UserActions';
import isEmpty from 'lodash/isEmpty';
import Error from '../components/Error';
import Loading from '../components/Loading';
import {Button} from 'react-bootstrap';
import {Link} from 'react-router-dom';
import map from 'lodash/map';

@connect(state => ({users: state.users}), {fetchUsers, onDeleteUser})
export default class UsersContainer extends Component {
    static propTypes = {
        fetchUsers: PropTypes.func,
        onDeleteUser: PropTypes.func,
        users: PropTypes.shape({
            loading: PropTypes.bool,
            error: PropTypes.object,
            items: PropTypes.array
        }),
        history: PropTypes.object,
    };

    componentDidMount() {
        this.props.fetchUsers();
    }

    handleDelete = (id) => {
        this.props.onDeleteUser(id);
    };

    handleRowClick = (id) => {
        this.props.history.push(`/admin/user/${id}`);
    };

    openImages = (id, event) => {
        event.preventDefault();
        event.stopPropagation();
        this.props.history.push(`/images/${id}`);
    };

    render() {
        const {users} = this.props;
        if (isEmpty(users)) {
            return false;
        }
        const {loading, error} = users;
        if (!isEmpty(error)) {
            return <Error error={error}/>;
        }
        if (loading) {
            return <Loading/>;
        }
        const headers = [
            {path: 'id', label: 'Id'},
            {path: 'firstName', label: 'First Name'},
            {path: 'lastName', label: 'Last Name'},
            {path: 'email', label: 'Email'},
            {path: 'usageLimit', label: 'Usage Limit'},
            {path: 'currentUsage', label: 'Current Usage'},
            {path: 'downloadCount', label: 'Downloaded'},
            {path: 'printCount', label: 'Printed'},
            {path: 'admin', label: 'Admin'},
        ];

        const ImagesButtonComponent = ({rowData}) => (
            <Button title="Open Images" bsStyle="info" onClick={(e) => {
                this.openImages(rowData.id, e)
            }}>
                <i className="fa fa-th"/>{' Images'}
            </Button>
        );

        const extraColumnMetadata = [
            {
                displayName: '',
                columnName: '_images_',
                visible: true,
                cssClassName: 'imagesCol',
                customComponent: ImagesButtonComponent
            },
        ];

        const results = map(users, user => ({...user, admin: user.admin ? 'yes' : ''}));

        return (
            <div className="page">
                <div className="page_contents" style={{width: 1400}}>
                    <h1>{'Users'}</h1>
                    <div className="card" style={{minHeight: 600}}>
                        <Link to="/admin/user">
                            <Button bsStyle="success" style={{marginBottom: 20}}>
                                <i className="fa fa-plus"/>
                                {' Create new user'}
                            </Button>
                        </Link>
                        <SearchResultsTable
                            headers={headers}
                            results={results}
                            onDelete={this.handleDelete}
                            onRowClick={this.handleRowClick}
                            extraColumnMetadata={extraColumnMetadata}
                            resultsPerPage={20}
                            nameGetter={d => `user '${d.email}'`}
                        />
                    </div>
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/containers/UsersContainer.js